module.exports = __webpack_public_path__ + "static/logo-4129ff4d802b1e81bd9a9de4004c89e0.png";